import { RootState } from '../store';

export const getTableWorkspaces = (state: RootState) => state.workspaces.table;

export const getWorkspaceName = (state: RootState) => {
    return (id: string) =>  {
        const workspace = state.workspaces.all.find((e) => e.id === id);
        if (workspace) {
            return workspace.name || workspace.id;
        } else {
            return '...'; // id;
        }
    };
};

export const workspaceOptions = (state: RootState) => {
    return state.workspaces.all.map((workspace) => ({
        label: workspace.name,
        value: workspace.id,
    }));
};

export const getSingleWorkspace = (state: RootState) => state.workspaces.singleWorkspace;